import axios from 'axios';
import { setupInterceptors } from './interceptors';
import { APIURL } from '../models/api-base';
import { TOKENSTORAGE } from '../models/constants';

const axiosInstance = axios.create({
    baseURL: APIURL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const storedData = localStorage.getItem(TOKENSTORAGE);
        const data = JSON.parse(storedData);
        const token = data?.state?.token;
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Inicializar interceptores de errores
export function initAxios(showError) {
    setupInterceptors(axiosInstance, showError);
}

export default axiosInstance;
